// ── Figure registry ───────────────────────────────────────────────────────────
// One entry per Studio preset (see ../presets.ts). Figure components import
// only ../primitives and ../Icons — never ./index — so there is no cycle.

import type { ComponentType } from 'react';
import type { FigurePreset } from '../presets';
import ProfitTargetChallenge from './ProfitTargetChallenge';
import ProfitTargetFunding from './ProfitTargetFunding';
import DailyLossLimit from './DailyLossLimit';
import MaxDrawdownTrailing from './MaxDrawdownTrailing';
import MaxPositionLossTwoTrades from './MaxPositionLossTwoTrades';
import ConsistencyExample from './ConsistencyExample';
import ConsistencyCalculator from './ConsistencyCalculator';
import ContractSizes from './ContractSizes';
import LeverageExample from './LeverageExample';
import TradingCommission from './TradingCommission';
import ScalpingTenTrades from './ScalpingTenTrades';
import MinimumTradingDays from './MinimumTradingDays';
import PayoutCalculator from './PayoutCalculator';
import PayoutEligibility from './PayoutEligibility';
import MaximumPayoutRequest from './MaximumPayoutRequest';
import BufferAfterPayout from './BufferAfterPayout';
import PayoutCapCalculation from './PayoutCapCalculation';
import NewProfitRequirement from './NewProfitRequirement';
import ProfitSplit from './ProfitSplit';

export const FIGURES: Partial<Record<FigurePreset, ComponentType>> = {
  profitTargetChallenge: ProfitTargetChallenge,
  profitTargetFunding: ProfitTargetFunding,
  dailyLossLimit: DailyLossLimit,
  maxDrawdownTrailing: MaxDrawdownTrailing,
  maxPositionLossTwoTrades: MaxPositionLossTwoTrades,
  consistencyExample: ConsistencyExample,
  consistencyCalculator: ConsistencyCalculator,
  contractSizes: ContractSizes,
  leverageExample: LeverageExample,
  tradingCommission: TradingCommission,
  scalpingTenTrades: ScalpingTenTrades,
  minimumTradingDays: MinimumTradingDays,
  payoutCalculator: PayoutCalculator,
  payoutEligibility: PayoutEligibility,
  maximumPayoutRequest: MaximumPayoutRequest,
  bufferAfterPayout: BufferAfterPayout,
  payoutCapCalculation: PayoutCapCalculation,
  newProfitRequirement: NewProfitRequirement,
  profitSplit: ProfitSplit,
};
